import React from 'react';
import { Select } from 'antd';

export default function Selects({ fieldId, options, label, onChange, formData, value, width = '100%', disabled }) {

    let estilo = { cursor: "pointer", height: "38px", width: width, borderRadius: "10px" }

    return (
        <Select
            showSearch
            placeholder={label}
            optionFilterProp="children"
            disabled={disabled}
            onChange={(value) => onChange(fieldId, value)}
            style={{ ...estilo }}
            value={formData?.[fieldId] || value || []}
            size={'small'}
            filterOption={(input, option) =>
                (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
            }
            options={options}
        />

    )
}